module.exports = __webpack_public_path__ + "static/media/proj4_img7.8fc9d5cb.jpg";